import React, { memo } from 'react';
import MainRouter from './MainRouter';
import MainLayout from '@/layout/MainLayout';
import 'antd/es/slider/style';
import NewEmailDialog from '@/components/NewEmailDialog';
import { useUser } from '@dofleini/security';
import PublicLayout from '@/layout/PublicLayout';

const MainApp = () => {
  const { isAuthenticated } = useUser();
  const AppLayout = isAuthenticated ? MainLayout : PublicLayout;
  return (
    <AppLayout>
      <MainRouter/>
      <NewEmailDialog/>
    </AppLayout>
  );
};

export default memo(MainApp);
